import React from "react";

const Waveform = ({ isActive }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "2px",
        height: "20px",
        marginLeft: "8px",
      }}
    >
      {[1, 2, 3, 4, 5].map((bar, i) => (
        <div
          key={i}
          style={{
            width: "3px",
            height: isActive ? "100%" : "6px",
            background: "#1976d2",
            borderRadius: "2px",
            animation: isActive
              ? `wave 1s ease-in-out ${i * 0.1}s infinite`
              : "none",
          }}
        />
      ))}
      <style>
        {`
          @keyframes wave {
            0% { height: 6px; }
            50% { height: 20px; }
            100% { height: 6px; }
          }
        `}
      </style>
    </div>
  );
};

export default Waveform;
